import type { PropsWithChildren } from 'react';
import React from 'react';

const FormContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return <form className="flex w-full flex-col space-y-2">{children}</form>;
};

export default FormContainer;
